<template>
  <date-filter-value :date="date"
                     :format="format"
  >
    <template #icon>
      <date-to-icon class="mb-1"/>
    </template>
  </date-filter-value>
</template>

<script>
import DateToIcon from '@/assets/images/icons/DateToIcon'
import DateFilterValue from './DateFilterValue'
import datetimeUtils from '@/utils/datetime.utils'

export default {
  name: 'DateToFilterValue',

  components: { DateFilterValue, DateToIcon },

  props: {
    date: {
      type: String,
      required: true
    }
  },

  computed: {
    format() {
      return datetimeUtils.toMoment(this.date).format('HH:mm') === '23:59' ?
        'D MMM, YY' :
        'D MMM, YY [at] HH:mm'
    }
  }
}
</script>
